/** Canonical `KeyboardEvent.key` values: read via `KEYBOARD_KEYS.ENTER` so legacy-spelling typos (`'Esc'` vs `'Escape'`) cannot silently break a11y close-on-escape paths. */

export const KEYBOARD_KEYS = {
	ENTER: 'Enter',
	ESCAPE: 'Escape',
	SPACE: ' ',
	TAB: 'Tab',
	ARROW_UP: 'ArrowUp',
	ARROW_DOWN: 'ArrowDown',
	ARROW_LEFT: 'ArrowLeft',
	ARROW_RIGHT: 'ArrowRight',
	HOME: 'Home',
	END: 'End',
	DELETE: 'Delete',
	BACKSPACE: 'Backspace',
	SHIFT: 'Shift',
} as const;

/** Enter or Space -- the keys that ACTIVATE a button-role element, which a custom clickable (a card, a breadcrumb span,
 *  a sortable header) must honour on keydown as a native button does.
 *  @runtime-derived-ssot-helper (const-leaf-pinned): both keys are read off the same-leaf `KEYBOARD_KEYS` SSOT. */
export function isActivationKey(key: string): boolean {
	return key === KEYBOARD_KEYS.ENTER || key === KEYBOARD_KEYS.SPACE;
}

/** Enter, Space or Escape -- the keys that dismiss a click-to-close overlay (a filter panel's backdrop, a dialog's).
 *  @runtime-derived-ssot-helper (const-leaf-pinned): every key it answers for is read off the same-leaf
 *  `KEYBOARD_KEYS` SSOT, never spelled here. */
export function isOverlayDismissKey(key: string): boolean {
	return key === KEYBOARD_KEYS.ENTER || key === KEYBOARD_KEYS.SPACE || key === KEYBOARD_KEYS.ESCAPE;
}
